import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Modal, Form, Button } from "react-bootstrap";
import { TextareaAutosize } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const AccountStatusDialog = (props) => {
  const {
    onClose,
    value: valueProp,
    accountReason,
    open,
    accountList,
    ...other
  } = props;
  const [value, setValue] = React.useState(valueProp);
  const [reason, setReason] = React.useState(accountReason);
  const radioGroupRef = React.useRef(null);
  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
      setReason(accountReason);
    }
  }, [valueProp, open, accountReason]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value, reason);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      {...other}
    >
      <DialogTitle>Account Status</DialogTitle>
      <DialogContent dividers>
        {/* <RadioGroup
          ref={radioGroupRef}
          aria-label="ringtone"
          name="ringtone"
          value={value}
          onChange={handleChange}
        >
          {accountList.map((option) => (
            <FormControlLabel
              value={option.account_status}
              key={option.id}
              control={<Radio />}
              label={option.account_status}
            />
          ))}
        </RadioGroup> */}
        <FormControl style={{ width: "100%" }}>
          <InputLabel id="demo-simple-select-helper-label">
            Account Status
          </InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={value}
            label="Account Status"
            onChange={handleChange}
          >
            {accountList.map((option) => (
              <MenuItem value={option.account_status}>
                {option.account_status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <Form.Label>
            Rational <span style={{ color: "red" }}>*</span>
          </Form.Label>
          <TextareaAutosize
            id="filled-required"
            variant="outlined"
            label="note"
            value={reason}
            onChange={(event) => {
              setReason(event.target.value);
            }}
            style={{ height: "90px", paddingInline: "5px" }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk} disabled={value == '' || reason == '' }>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountStatusDialog;
